import { getProductType, ProductEnum } from "../../../constants/login";
import { reserveSettingsGroups } from "./reserve";
import { retailSettingsGroups } from "./retail";
import { sncSettingsGroups } from "./snc";
import { SettingsGroup } from "./types";
import { versaSettingsGroups } from "./versa";

export type { SettingsGroup } from "./types";

/** Versa-only grouped Settings files. Golf/Spa use sheet-by-sheet order in orderRegistry.ts. */
const settingsGroupsByProduct: Partial<Record<ProductEnum, SettingsGroup[]>> = {
  [ProductEnum.VERSA]: versaSettingsGroups,
  [ProductEnum.TEST]: versaSettingsGroups,
  [ProductEnum.RETAIL]: retailSettingsGroups,
  [ProductEnum.SALES_AND_CATETING]: sncSettingsGroups,
  [ProductEnum.RESERVE_ACTIVITIES]: reserveSettingsGroups,
  [ProductEnum.RESERVE_DINING]: reserveSettingsGroups,
};

/** Returns settings group definitions for the given product. */
export const getSettingsGroups = (productId: number): SettingsGroup[] => {
  const productType = getProductType(productId) as ProductEnum | undefined;
  return productType ? (settingsGroupsByProduct[productType] ?? []) : [];
};
